<div class="form-group mb-3" [formGroup]="parentForm">
  <div class="select">
    <label *ngIf="label" class="form-label" [for]="id">{{ label }}</label>
    <select
      [id]="id"
      class="form-control"
      [formControlName]="formControlProp ?? null"
    >
      <option *ngIf="emptyOption" value=""></option>
      <ng-template
        *ngFor="let item of items"
        [ngTemplateOutlet]="template ?? null"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-template>
    </select>
  </div>

  <div class="content mt-1">
    <ng-content></ng-content>
  </div>
</div>
